<template>
  <div
    class="entry-preview"
    :style="{'pointer-events': (disableClicks)? 'none': ''}"
  >
    <div
      ref="container"
      class="preview__container"
    >
      <div
        class="preview__wrapper"
        :style="{
          width: '100%',
          'max-width': `${iframe.innerWidth / iframeZoom}px`,
          height: `${iframe.innerHeight / iframeZoom}px`,
        }"
      >
        <iframe
          class="preview__iframe"
          :srcdoc="content"
          scrolling="no"
          frameborder="0"
          :style="{
            width: `${iframe.innerWidth * iframeZoom}px`,
            height: `${iframe.innerHeight * iframeZoom}px`,
            transform: `scale(${iframeScale})`,
            zoom: iframeScale,
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
/** NOTE: This components seems equal as pages/entries/Preview.vue
 * But they are NOT the same
*/
export default {
  name: 'EditPreview',
  props: {
    content: {
      type: String,
      default: '',
    },
    /** This property will prevent clicks inside the iframe */
    disableClicks: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      iframeScale: 1,
      iframeZoom: 1,
      iframe: {
        innerWidth: 0,
        innerHeight: 0,
      },
    };
  },
  mounted() {
    /** Receive iframe message
     * https://github.com/hello-seer/stylelab-backend/blob/c6842b021d33fc687800c0d2f5937347eeeb5294/stylelab/templates/pages/render_edit.html#L241
     * */
    window.addEventListener('message', this.receiveMessage);

    /** We are listening resize - this solves responsive and resizing the browser */
    this.$nextTick(() => {
      this.onResize();
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeDestroy() {
    // Remove the events created on Mount so we don't have ghost events
    window.removeEventListener('message', this.receiveMessage);
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      const deltaWidth = 865; // This is an arbitrary number relative to edit width (900px)
      const scale = this.$refs.container.scrollWidth / deltaWidth;
      const zoom = deltaWidth / this.$refs.container.scrollWidth;

      // We are scaling down only
      this.iframeScale = scale > 1 ? 1 : scale;
      this.iframeZoom = zoom < 1 ? 1 : zoom;
    },
    receiveMessage(message) {
      // Prevents from proccess vue-tools or other messages
      if (!message.data.innerHeight) {
        return;
      }
      this.iframe = message.data;
      this.onResize();
    },
  },
};
</script>

<style lang="scss" scoped>
.preview {
  &__container {
    background-color: white;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    justify-content: center;
  }
  &__iframe {
    // These are overwritten
    width: 1920px; // Initial width
    zoom: 0.5;
    transform: scale(0.5);
    transform-origin: 0 0;
  }

  &__wrapper {
    width: 800px; // This is overwritten by iframe.innerWidth
    height: 2080px; // This is overwritten by iframe.innerHeight
    padding: 0;
    overflow: hidden;
  }
}
</style>
